module.exports = __webpack_public_path__ + "img/man_night_sky.683e3b28.png";